(function NotificationConfigFindController() {
    'use strict';

    angular.module('NotificationConfig')
        .controller('NotificationConfigFindController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'authExtend', 'adminNotificationConfigService', 'documentTypeService', 'adminRoleService', 'alerts', 'storageService','adminDocumentTypeService',
            function importProcessController($scope, config, $state, $translate, errors, authExtend, adminNotificationConfigService, documentTypeService, adminRoleService, alerts, storageService, adminDocumentTypeService) {

                $scope.hideAddBtn = !authExtend.isInRole('NOTIFICATION WRITE');
                $scope.all = { name: "Todos", id: 0 };
                $scope.emptyOu = true;

                $scope.findAction = function () {
                    $scope.find.showNoData = false;
                    storageService.setNotifFilter($scope.find);

                    var docTypeId = null;
                    var roleId = null;
                    if ($scope.optionsDocumentTypes[0]) {
                        docTypeId = $scope.find.documentTypeId === 0 ? null : $scope.find.documentTypeId;
                    }

                    if ($scope.optionsRoles[0]) {
                        roleId = $scope.find.roleId === 0 ? null : $scope.find.roleId;
                    }

                    if ($scope.find.organizationalUnit && $scope.find.organizationalUnit.id) {
                        $scope.find.organizationalUnitId = $scope.find.organizationalUnit.id;
                    } else {
                        $scope.find.organizationalUnitId = undefined;
                    }

                    return adminNotificationConfigService.get($scope.find.name, $scope.find.templateName, docTypeId, roleId, $scope.find.organizationalUnitId).then(function getOk(result) {
                        $scope.notificationsConfigs = result;

                        if ($scope.notificationsConfigs.length === 0)
                            $scope.find.showNoData = true;

                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.load = function () {
                    $scope.optionsDocumentTypes = [];
                    $scope.optionsRoles = [];

                    $scope.find = storageService.getNotifFilter();

                    $scope.find.organizationalUnit = {};

                    if ($scope.find.organizationalUnit && $scope.find.organizationalUnit.id) {
                        $scope.find.organizationalUnitId = $scope.find.organizationalUnit.id;
                    } else {
                        $scope.find.organizationalUnitId = authExtend.getOrganizationId();
                    }

                    adminDocumentTypeService.get(undefined, $scope.find.organizationalUnitId, undefined, undefined).then(function (result) {
                        $scope.optionsDocumentTypes = result.sort(function (a, b) {
                            return a.name.localeCompare(b.name);
                        });
                        $scope.optionsDocumentTypes.splice(0, 0, $scope.all);

                        if (!$scope.find.documentTypeId) {
                            $scope.find.documentTypeId = $scope.optionsDocumentTypes[0].id;
                        }
                    }, function (error) {
                        errors.showError(error);
                    });

                    adminRoleService.get('', $scope.find.organizationalUnitId).then(function (result) {
                        $scope.optionsRoles = result.value;

                        $scope.optionsRoles.splice(0, 0, $scope.all);

                        if (!$scope.find.roleId) {
                            $scope.find.roleId = $scope.optionsRoles[0].id;
                        }
                    }, function (error) {
                        errors.showError(error);
                    });

                    $scope.notificationsConfigs = [];
                    $scope.findAction();
                };

                $scope.modify = function (notificationConfig) {
                    $state.go('notification-config-edit', { id: notificationConfig.id });
                };

                $scope.add = function () {
                    $state.go('notification-config-add');
                };

                $scope.view = function (notificationConfig) {
                    $state.go('notification-config-detail', { id: notificationConfig.id });
                };

                $scope.delete = function (notif) {
                    return $translate(['Warning', 'NotificationDeleteConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.NotificationDeleteConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                            if (result) {
                                return adminNotificationConfigService.delete(notif.id).then(function getOk(resulta) {
                                    errors.showSuccess('NotificationDeleteSuccess');
                                    $scope.findAction();
                                }, function (error) {
                                    errors.showError(error);
                                });
                            }
                        });
                    });
                };

                $scope.load();
            }
        ]);
})();